import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { forgotPassword } from '../../api'

import Finished from '../Pages/ForgotPasswordFinished'
import Form from './Form'
import { Logo, Button } from '../Common'

import style from './ForgotPassword.scss'

class ForgotPassword extends Component {
  static propTypes = {
    search: PropTypes.object,
  }

  state = {
    loading: false,
    status: undefined,
  }

  handleSubmit = ({ email }, callback) => {
    if (this.state.loading) return
    this.setState(
      (state) => ({
        ...state,
        loading: true,
      }),
      () => {
        forgotPassword(email).then(
          () => {
            this.setState((state) => ({
              ...state,
              status: 'ok',
            }))
          },
          (err) => {
            callback(err)
          },
        )
      },
    )
  }

  render() {
    const { search } = this.props
    const { loading, status } = this.state

    let content
    if (status === 'ok') {
      content = <Finished />
    } else {
      content = <Form search={search} loading={loading} onSubmit={this.handleSubmit} />
    }

    return (
      <div className={style.wrapper}>
        <Logo className={style.logo} />
        {status !== 'ok' && (
          <Link to="/login" className={style.link}>
            <Button theme="white" className={style.button} xl>
              voltar
            </Button>
          </Link>
        )}
        {content}
      </div>
    )
  }
}

export default ForgotPassword



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPassword.js